import { CustomizationEntry } from "../types";

export enum GeneralCategory {
    ActivationAndModes = 'Activation and Experience',
    Launcher = 'Launcher',
    PlacementAndOpening = 'Placement & opening',
    ConnectionAndSession = 'Connection & session',
}

export enum GeneralSubCategory {
    ChatAndVoiceSwitching = 'Chat and voice switching',
    WidgetAvailability = 'Widget availability',
    Behavior = 'Behavior',
    Icons = 'Icons',
    Colors = 'Colors',
    WelcomeBanner = 'Welcome banner',
    ScreenPlacement = 'Screen placement',
    OpeningBehavior = 'Opening behavior',
    Integration = 'Integration',
    Authentication = 'Authentication',
    SessionAndCookies = 'Session & cookies',
}

export type GeneralCustomizationEntry = CustomizationEntry<GeneralCategory, GeneralSubCategory>;
